<div class="device-container">

  <div style="order: 1; flex-shrink: 0;">
    <p-accordion class="device-group-accordion">
      @for (container of topLevelContainers; track container; let i = $index) {
      <p-accordionTab [header]="container.Name" [selected]="i === 0">
        <div style="overflow: auto; max-height: 500px;">
          <ul #containerGroup [ngStyle]="{'padding-left': container.Name === 'Custom Groups' ? '0' : '28'}"
            (contextmenu)="regularcontext.show($event)">
            @if (container.Name !== 'Custom Groups') {
            @for (group of getContainerGroups(container); track group) {
            <li #accordion class="generic-device-group" [class.selected-device-group]="group === selectedDeviceGroup"
              (click)="onGroupNameClick(group)" (contextmenu)="setSelectedDeviceGroup(group)">
              {{groupDisplayName(group)}}
            </li>
            }
            } @else {
            <span #treeEntries (contextmenu)="customcontext.show($event)">
              <p-tree class="w-full md:w-30rem unpadded-tree" selectionMode="single" [value]="treeNodes"
                [(selection)]="selectedTreeNode" (onNodeClick)="onGroupNameClick($event)">
                <ng-template let-node pTemplate="default">
                  <span [ngClass]="{'selected-node': selectedDeviceGroup === node.data, 'unselected-node': selectedDeviceGroup !== node.data}"
                    (click)="onGroupNameClick(node.data)" (contextmenu)="setSelectedDeviceGroup(node.data)">
                    {{ node.label }}
                  </span>
                </ng-template>
              </p-tree>
            </span>
            }
          </ul>
          @if (container.Name === 'Custom Groups') {
          <button class="add-group-button" (click)="createNewDeviceGroup(null, this.userGroupsContainer.VdgcGuid, true)"
            pButton icon="fa fa-plus-square-o" title="Create new custom device group..."></button>
          }
        </div>
      </p-accordionTab>
      }
    </p-accordion>
  </div>
  <p-contextMenu #regularcontext [model]="items" appendTo="body"></p-contextMenu>
  <p-contextMenu #customcontext [model]="customGroupsItems" appendTo="body"></p-contextMenu>

  <div style="order: 2; flex-grow: 1; margin-left:5px; overflow-x:hidden;">
    <div [ngbNavOutlet]="nav"></div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" class="nav nav-pills justify-content-center"
      style="padding-top: 6px;" (navChange)="onTabChange($event)">

      <li [ngbNavItem]="1">
        <a ngbNavLink class="link">Devices</a>
        <ng-template ngbNavContent>
          <div style="border-style: solid; border-color: rgb(235,235,235);">
            <device-list [loading]="loading" (onShowDeviceOnMap)="showDeviceOnMap($event)"></device-list>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="2">
        <a ngbNavLink class="link">Map</a>
        <ng-template ngbNavContent>
          <div class="map-container">
            <!--@defer (on viewport){-->
            <layer2map (editDeviceGroup)="editDeviceGroup()" [selected]="selected"></layer2map>
            <!--}
          @placeholder {
          <span>Loading map...</span>
          }-->
          </div>
        </ng-template>
      </li>
    </ul>

  </div>

  <device-group-dialog [(visible)]="deviceGroupDialogVisible" [target]="selectedViewerDeviceGroup"
    [network]="network"></device-group-dialog>

  <confirmation-dialog message="Deleting this group will delete its children as well. Proceed?"
    [display]="displayDeleteChildrenConfirm" (onYes)="deleteDeviceGroup()" (onNo)="cancelDeleteChildren()">
  </confirmation-dialog>

</div>